import { useUser } from '@folklore/auth';
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton from '../buttons/StyledButton';
import ChevronIcon from '../icons/Chevron';
import CircleLock from '../icons/CircleLock';

import styles from '../../../styles/partials/complete-form-entry.module.scss';

function CompleteFormEntry({ className = null }: { className: string | null }) {
    const themeClassName = useThemeClassName(styles);
    const url = useUrlGenerator();
    const { draws = null } = useUser() || {};

    const drawWithFormEntry =
        (draws || []).find(({ formEntry = null }) => {
            const { value = null } = formEntry || {};
            return formEntry !== null && value === null;
        }) || null;

    if (drawWithFormEntry === null) {
        return null;
    }

    const { title = null } = drawWithFormEntry;

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.inner}>
                <StyledButton href={url('account')} className={styles.button}>
                    <CircleLock className={styles.icon} />
                    <span className={styles.label}>
                        <FormattedMessage
                            defaultMessage="Unlock access to the {draw}"
                            description="Button label"
                            values={{
                                draw: (title || '').toLowerCase(),
                            }}
                        />
                    </span>
                    <ChevronIcon
                        direction="right"
                        className={classNames([styles.icon, styles.arrow])}
                    />
                </StyledButton>
            </div>
        </div>
    );
}

export default CompleteFormEntry;
